/* ============================================================
   Herb Terra recently-viewed tracker.
   On PDP view: writes {handle, title, image, price} to localStorage.
   On cart open: reads localStorage and renders into
   [data-recently-viewed-list]. LRU cap 10. Filters out items
   already in cart.
   ============================================================ */

(function () {
  'use strict';

  if (window.__htRecentlyViewedLoaded) return;
  window.__htRecentlyViewedLoaded = true;

  var STORAGE_KEY = 'htc_recent_v1';
  var MAX = 10;
  var RENDER_LIMIT = 3;

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      /* quota; non-fatal */
    }
  }

  function trackCurrentPDP() {
    var meta = document.querySelector('meta[property="og:type"][content="product"]');
    if (!meta) return;

    var handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return;
    var handle = handleMatch[1];

    var titleEl = document.querySelector('h1.product__title, h1.main-product__title, h1[class*="product"][class*="title"]');
    var title = titleEl ? titleEl.textContent.trim() : (document.title.split(/[|\-]/)[0] || '').trim();

    var imgEl = document.querySelector('meta[property="og:image"]');
    var image = imgEl ? imgEl.getAttribute('content') : null;

    var priceEl = document.querySelector('meta[property="og:price:amount"]')
      || document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
    var price = '';
    if (priceEl) {
      price = priceEl.getAttribute('content') || priceEl.textContent.trim();
    }

    if (!title || !image) return;

    var store = readStore();
    store = store.filter(function (it) { return it.handle !== handle; });
    store.unshift({
      handle: handle,
      title: title,
      image: image,
      price: price,
      ts: Date.now()
    });
    if (store.length > MAX) store = store.slice(0, MAX);
    writeStore(store);
  }

  function getCurrentCartHandles() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).map(function (i) { return i.handle; });
      })
      .catch(function () { return []; });
  }

  function renderInto(container) {
    if (!container) return;
    var list = container.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    var store = readStore();
    if (!store.length) {
      container.hidden = true;
      return;
    }

    getCurrentCartHandles().then(function (cartHandles) {
      var visible = store.filter(function (it) { return cartHandles.indexOf(it.handle) === -1; }).slice(0, RENDER_LIMIT);
      if (!visible.length) {
        container.hidden = true;
        return;
      }

      var html = visible.map(function (it) {
        var img = it.image;
        var thumb = img && img.indexOf('?') === -1 ? img + '?width=192' : img;
        return ''
          + '<li class="ht-cart-recent__item">'
          +   '<a class="ht-cart-recent__link" href="/products/' + escapeHtml(it.handle) + '">'
          +     '<span class="ht-cart-recent__img">'
          +       '<img src="' + escapeAttr(thumb) + '" alt="" loading="lazy" width="96" height="96">'
          +     '</span>'
          +     '<span class="ht-cart-recent__name">' + escapeHtml(it.title) + '</span>'
          +   '</a>'
          + '</li>';
      }).join('');
      list.innerHTML = html;
      container.hidden = false;
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function renderAll() {
    document.querySelectorAll('[data-recently-viewed]').forEach(renderInto);
  }

  function observeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class' && drawer.classList.contains('active')) {
          renderAll();
        }
      });
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    trackCurrentPDP();
    renderAll();
    observeCartDrawer();

    // Re-render on cart update (Dawn fires custom event from cart.js)
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, renderAll);
    }
    document.addEventListener('cart:refresh', renderAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
